
import {Component, OnInit, ViewContainerRef, Input, Renderer2, EventEmitter, Output} from '@angular/core';
import{ NdmsFormControlComponent } from '../ndms-form-control/ndms-form-control.component';


@Component({
  selector: 'ndms-id-select',
  templateUrl: './ndms-id-select.component.html',
  styleUrls: ['./ndms-id-select.component.scss']
})

export class NdmsIdSelectComponent extends NdmsFormControlComponent implements OnInit {

  constructor(viewContainerRef: ViewContainerRef) {
    super(viewContainerRef);
  }
  ngOnInit() {

  }
  @Input() descriptionField: string = 'description';
  @Input() hasNullValue: boolean = true;
  @Input() defaultValue?: string =undefined;
  @Input() label: string;
  @Input() lookup:string;
  @Input() required: string;
  @Input() itemList: any[];
  @Input() useItemList: boolean;
  @Output() select: EventEmitter<any> = new EventEmitter<any>();
 // value:any = {};
  compareFn(c1, c2): boolean {
      return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }
  onSelectFinish($event){
    this.select.emit($event);
  }
  getText() {
    if(!this.value || !this.value.id)
    {
      return 'N/A';
    }
    return this.value[this.descriptionField];
  }
  protected getLookups(lookup?: string) {
    if(this.useItemList){
      return this.itemList;
    }

    var lookups = this.hasFormComponent.lookupService.getLookupValue(lookup || this.lookup);
    return lookups;
  }
}
